import React, { useEffect } from 'react';
import { FiArrowLeft, FiPrinter } from 'react-icons/fi';
import { useLocation, useNavigate } from 'react-router-dom';

const Namuna7Receipt = ({ transaction: propTransaction, onBack }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const transaction = propTransaction || location.state?.transaction;

    // Hide sidebar and navbar when printing
    useEffect(() => {
        const style = document.createElement('style');
        style.textContent = `
            @media print {
                body * {
                    visibility: hidden;
                }
                .print-receipt, .print-receipt * {
                    visibility: visible;
                }
                .print-receipt {
                    position: absolute;
                    left: 0;
                    top: 0;
                    width: 100%;
                }
            }
        `;
        document.head.appendChild(style);

        return () => {
            document.head.removeChild(style);
        };
    }, []);

    const formatDate = (dateString) => {
        if (!dateString) {
            const today = new Date();
            return today.toLocaleDateString('mr-IN', { day: '2-digit', month: '2-digit', year: 'numeric' }).replace(/\//g, '/');
        }
        const date = new Date(dateString);
        return date.toLocaleDateString('mr-IN', { day: '2-digit', month: '2-digit', year: 'numeric' }).replace(/\//g, '/');
    };

    const formatAmount = (amount) => {
        if (!amount) return '1,000.00';
        return parseFloat(amount).toFixed(2);
    };

    // Ensure transaction has default values
    const safeTransaction = {
        date: transaction?.date || new Date().toISOString().split('T')[0],
        challanNo: transaction?.challanNo || '1',
        personName: transaction?.personName || 'sangram sunil shinde',
        totalAmount: transaction?.totalAmount || 1000,
        transactions: transaction?.transactions || [
            { accountName: 'खाते गट 1 (-)', narration: '' }
        ]
    };

    const handlePrint = () => {
        window.print();
    };

    const handleBack = () => {
        if (onBack) {
            onBack();
        } else {
            navigate(-1);
        }
    };

    const ReceiptContent = () => (
        <div className="border-2 border-black p-6 w-full">
            {/* Header Section */}
            <div className="text-center mb-6">
                <h1 className="text-xl font-bold">ग्रामपंचायत इनाम धामणी</h1>
                <h2 className="text-lg font-semibold mt-2">नमुना ७</h2>
                <h3 className="text-lg font-semibold">सामान्य पावती</h3>
            </div>

            {/* Date and Receipt Number */}
            <div className="grid grid-cols-2 gap-4 mb-4">
                <div>
                    <span className="font-semibold">दिनांक : </span>
                    <span>{formatDate(safeTransaction.date)}</span>
                </div>
                <div>
                    <span className="font-semibold">पावती क्रमांक : </span>
                    <span>{safeTransaction.challanNo}</span>
                </div>
            </div>

            <div className="mb-6">
                <span className="font-semibold">पुस्तक क्रमांक : </span>
                <span></span>
            </div>

            {/* Transaction Details */}
            <div className="mb-6">
                <p className="leading-relaxed">
                    <span className="font-semibold">{safeTransaction.personName}</span> कडुन
                    {safeTransaction.transactions?.map((item, index) => (
                        <span key={index}>
                            {item.accountName}
                            {item.narration && ` ${item.narration}`}
                        </span>
                    ))} जि.प. कडुन च्या खाती रक्कम रुपये
                    <span className="font-semibold"> {formatAmount(safeTransaction.totalAmount)} </span>
                    मिळाली.
                </p>
            </div>

            {/* Signature */}
            <div className="mt-8 mb-6">
                <div className="border-t border-black pt-2 inline-block">
                    <span>ग्रामपंचायत अधिकारी/क्लार्क</span>
                </div>
            </div>

            {/* Notes Section */}
            <div className="mt-8">
                <h4 className="font-semibold mb-3">टीप:</h4>
                <ol className="list-decimal list-inside space-y-2 text-sm">
                    <li>ही पावती कार्बन पेपरवरुन काढलेल्या दुहेरी प्रतीची असली पाहीजे.</li>
                    <li>नमुने देण्यात येतील तेव्हा पुस्तकांचे व पावत्यांचे क्रमांक छापण्यात किंवा शिक्याने वटविण्यात आलेले असली पाहिजे.</li>
                    <li>यथास्थिती ग्रामपंचायत अधिकारी किंवा पंचायतीच्या क्लार्क याने त्यास मिळालेल्या रकमेबद्दल पंचायतीच्या वतीने पावती दिली पाहीजे.</li>
                </ol>
            </div>
        </div>
    );

    return (
        <div className="min-h-screen bg-white p-4 print-receipt">
            <div className="max-w-full mx-auto">
                {/* Header */}
                <div className="flex justify-between items-center mb-6 no-print">
                    <button
                        onClick={handleBack}
                        className="flex items-center gap-2 text-blue-600 hover:text-blue-800"
                    >
                        <FiArrowLeft /> Back
                    </button>
                    <button
                        onClick={handlePrint}
                        className="flex items-center gap-2 bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
                    >
                        <FiPrinter /> Print
                    </button>
                </div>

                {/* Two Receipts Side by Side */}
                <div className="flex gap-4 receipt-container">
                    {/* First Receipt */}
                    <div className="flex-1 receipt-item">
                        <ReceiptContent />
                    </div>

                    {/* Second Receipt (Duplicate) */}
                    <div className="flex-1 receipt-item">
                        <ReceiptContent />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Namuna7Receipt;
